import { Component, OnInit } from '@angular/core';
import { IconBaseComponent } from '../icon-base/icon-base.component';

@Component({
  selector: 'app-icon-check-outline',
  templateUrl: './icon-check-outline.component.html',
  styleUrls: ['./icon-check-outline.component.scss']
})
export class IconCheckOutlineComponent extends IconBaseComponent implements OnInit {
  constructor() {
    super();
  }

  ngOnInit(): void {}
}
